<!--
 * @Auther: 罗耀祖
 * @Date: 2022-04-24 17:35:21
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-17 17:21:55
 * @name: 销售副总审批
 * @Description: 销售副总审批
 * @FilePath: \project\src\components\afterSale\dialog-approve-fuzongshenpi.vue
 * @Author: desktop
-->
<template>
  <el-dialog title="审批处理" width="650px" :visible.sync="show" @close="close">
    <div class="content">
      <div class="row">
        <font class="label">审批结果</font>
        <font class="text">审批通过</font>
      </div>
      <div class="row">
        <font class="label">总金额</font>
        <font class="text">{{ total_fee }}元</font>
      </div>
      <div class="row">
        <font class="label">收取费用</font>
        <div class="pay_fee">
          <el-input size="mini" v-model="pay_fee"></el-input>
          <font>元</font>
        </div>
      </div>
      <div class="row">
        <font class="label">备注</font>
        <el-input
          class="remark"
          type="textarea"
          :rows="2"
          placeholder="请输入备注..."
          v-model="remark"
        >
        </el-input>
      </div>
      <div class="btn-group">
        <el-button size="mini" @click="show = false">取消</el-button>
        <el-button size="mini" type="primary" @click="confirm">提交</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import issueService from "@/module/issue/issue.service";
import { debounceation } from "@/utils/decorator";
export default {
  data() {
    return {
      issueService: new issueService(),
      show: false,
      issue_id: "", //工单id
      run_id: "", 
      run_process_id: "", //工作流id
      remark: "", //备注
      total_fee: 0, //总费用
      pay_fee: "", //收取费用
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param {Object} item 传递数据
     */
    open(param) {
      this.issue_id = param.issue_id;
      this.run_id = param.run_id;
      this.run_process_id = param.run_process_id;
      this.issueService
        .getVeifyQuality({
          issue_id: param.issue_id,
          run_id: param.run_id,
          run_process_id: param.run_process_id,
        })
        .then((res) => {
          this.total_fee = res.data?.fee?.total_fee ?? 0;
          this.pay_fee = this.total_fee;
          this.show = true;
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 弹窗关闭回调
     */
    close() {
      this.remark = "";
      this.total_fee = 0;
      this.pay_fee = "";
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击提交
     */
    @debounceation(300)
    confirm() {
      if (!this.pay_fee || Number(this.pay_fee) === 0) {
        this.$message.error("收取费用须为大于0的数字");
        return;
      }
      this.issueService
        .secondBoss({
          issue_id: this.issue_id,
          run_process_id: this.run_process_id,
          pay_fee: this.pay_fee,
          act: "OK",
          remark: this.remark,
        })
        .then((res) => {
          this.$emit("finish");
          this.show = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  @extend .et-flex-column-normal;
  .row {
    width: 100%;
    margin-bottom: 18px;
    @extend .et-flex-normal;
    font-size: $Vars-font-content-size;
    .label {
      color: $Vars-font-important-color;
      font-weight: bold;
      margin-right: 10px;
      width: calc(7 * #{$Vars-font-content-size});
      line-height: 28px;
    }
    .text {
      color: $Vars-font-normal-color;
      line-height: 28px;
    }
    .pay_fee {
      flex: 1;
      @extend .et-flex-start;
      .el-input {
        width: 180px;
        margin-right: 10px;
      }
    }
    .remark {
      flex: 1;
    }
  }
  .btn-group {
    width: 100%;
    @extend .et-flex-center;
  }
}
</style>